import { render, staticRenderFns } from "./CartModal.vue?vue&type=template&id=1252ca5b&lang=pug&"
import script from "./CartModal.vue?vue&type=script&lang=js&"
export * from "./CartModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports